"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCardProductSizeFont = exports.BcCardType = void 0;
var BcCardType;
(function (BcCardType) {
    BcCardType[BcCardType["none-icon"] = 0] = "none-icon";
    BcCardType[BcCardType["icon"] = 1] = "icon";
    BcCardType[BcCardType["small"] = 2] = "small";
    BcCardType[BcCardType["small-img"] = 3] = "small-img";
})(BcCardType || (exports.BcCardType = BcCardType = {}));
var BcCardProductSizeFont;
(function (BcCardProductSizeFont) {
    BcCardProductSizeFont[BcCardProductSizeFont["normal"] = 0] = "normal";
    BcCardProductSizeFont[BcCardProductSizeFont["medium"] = 1] = "medium";
    BcCardProductSizeFont[BcCardProductSizeFont["large"] = 2] = "large";
})(BcCardProductSizeFont || (exports.BcCardProductSizeFont = BcCardProductSizeFont = {}));
